export const GET_CHANGE_LOGS = 'GET_CHANGE_LOGS'
